module.exports = __webpack_public_path__ + "assets/777853cc4ed089ca39ebcbeb3cb31df4.mp3";